exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".creating-invoices-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column; }\n  .creating-invoices-container .loading-container {\n    height: 80px !important; }\n", ""]);

// exports
